import { FBDate } from "./Globals"
import { InvestorId } from "./Investor"
import { PostId } from "./Post"


export enum ActivityType {
    FEED_VISIT = "Feed visit",
    FEED_DETAILED_VISIT = "Feed detailed item visit",
    DASHBOARD_VISIT = "Dashboard visit",
    PROJECT_VISIT = "Project visit",
    PROJECT_LIST_VISIT = "List project visit",
    NOTIFICATION_EMAIL_SENT = "Notification email sent",
    INVESTMENT_VISIT = "Investment visit",
    PROFILE_VISIT = "Profile visit",

}

type ProjectVisitPayload = {
    projectId: string
}

type InvestmentPayload = {
    step: string,
    projectId: string,
    investmentId: string
}

type DetailedPost = {
    postId: PostId
}

export type Payload = ProjectVisitPayload | InvestmentPayload | DetailedPost

type Activity = {
    investorId: InvestorId,
    chunkDate: FBDate,
    activity: ActivityType,
    payload?: Payload 
}

export type ActivityProps = {
    activityType: ActivityType,
    payload?: Payload
}

export default Activity